<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div class="container mt-4">
    <h3>Fakturakunder</h3>
    <div class="bo_responsive-users-table-header mt-4">
          <span class="right-align">
              <button type="button" class="bo_btn" @click="showCreateForm"> + Legg til fakturakunde </button>
          </span>
    </div>

    <div v-if="showForm" class="mt-4 mb-4" style="max-width:560px">
        <h5>{{ editingCustomer.id ? 'Rediger fakturakunde' : 'Ny fakturakunde' }}</h5>

        <div>
          <span class="ingredient-title">Navn *</span>
          <input class="form-control" type="text" v-model="editingCustomer.name"/>
        </div>

        <div>
          <span class="ingredient-title">Organisasjonsnummer</span>
          <input class="form-control" type="text" v-model="editingCustomer.organizationNumber"/>
        </div>

        <div>
          <span class="ingredient-title">Kontaktperson</span>
          <input class="form-control" type="text" v-model="editingCustomer.contactPerson"/>
        </div>

        <div>
          <span class="ingredient-title">Epost</span>
          <input class="form-control" type="text" v-model="editingCustomer.email"/>
        </div>

        <div>
          <span class="ingredient-title">Telefon</span>
          <input class="form-control" type="text" v-model="editingCustomer.phone"/>
        </div>

        <div>
          <span class="ingredient-title">Adresse</span>
          <input class="form-control" type="text" v-model="editingCustomer.address"/>
        </div>

        <div class="mt-3">
          <button v-if="editingCustomer.name.length > 0" type="button" class="bo_btn" @click="saveCustomer"> Lagre </button>
          <button v-else type="button" class="bo_btn" disabled="true"> Lagre </button>
          <button type="button" class="bo_btn ms-3" @click="cancelForm"> Avbryt </button>
        </div>
    </div>

    <div class="table-responsive-sm mt-3">
        <table class="table table-striped">
          <thead>
          <tr>
            <th></th>
            <th>Navn</th>
            <th>Org.nr</th>
            <th>Kontaktperson</th>
            <th>Epost</th>
            <th>Telefon</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="customer in customers" :key="customer.id">
              <td>
                <a class="remove-user-btn" @click="removeCustomer(customer)">
                  <img src="@/assets/images/remove.png" width="21" title="Slett"/>
                </a>
              </td>
              <td data-label="Navn">
                <span>{{ customer.name }}</span>
              </td>
              <td data-label="Org.nr">
                <span>{{ customer.organizationNumber }}</span>
              </td>
              <td data-label="Kontaktperson">
                <span>{{ customer.contactPerson }}</span>
              </td>
              <td data-label="Epost">
                <span>{{ customer.email }}</span>
              </td>
              <td data-label="Telefon">
                <span>{{ customer.phone }}</span>
              </td>
              <td>
                <a class="edit-user-btn" @click="editCustomer(customer)">
                  <img src="@/assets/images/edit.png" width="21" title="Rediger"/>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
    </div>
    <ConfirmDialogue ref="confirmDialogue"></ConfirmDialogue>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ConfirmDialogue from '@/components/other/ConfirmDialogue.vue';
import SettingsService from "@/services/settings/SettingsService";
import MerchantUtil from "@/util/MerchantUtil";

export default {
  components: {LoadingSpinner, ConfirmDialogue},
  data() {
    return {
      loading: true,
      customers: [],
      showForm: false,
      editingCustomer: this.emptyCustomer()
    };
  },
  mounted() {
    this.loadCustomers();
  },
  methods: {
    emptyCustomer(){
      return {
        type: "invoice_customer",
        merchant: "",
        name: "",
        organizationNumber: "",
        contactPerson: "",
        email: "",
        phone: "",
        address: "",
        active: true
      };
    },
    loadCustomers(){
      this.loading = true;
      SettingsService.listInvoiceCustomers().then(
          (response) => {
            this.customers = response.data;
            this.loading = false;
          },
          (error) => {
            console.log(error);
            this.loading = false;
          }
      );
    },
    showCreateForm(){
      this.editingCustomer = this.emptyCustomer();
      this.showForm = true;
    },
    editCustomer(customer){
      this.editingCustomer = Object.assign({}, customer);
      this.showForm = true;
    },
    cancelForm(){
      this.showForm = false;
      this.editingCustomer = this.emptyCustomer();
    },
    saveCustomer(){
      this.loading = true;
      this.editingCustomer.merchant = MerchantUtil.getMerchant();

      if(this.editingCustomer.id){
        SettingsService.editInvoiceCustomer(this.editingCustomer).then(
            (response) => {
              if(response.data){
                this.showForm = false;
                this.loadCustomers();
              }
              this.loading = false;
            },
            (error) => {
              console.log(error);
              this.loading = false;
            }
        );
      } else {
        SettingsService.createInvoiceCustomer(this.editingCustomer).then(
            (response) => {
              if(response.data){
                this.showForm = false;
                this.loadCustomers();
              }
              this.loading = false;
            },
            (error) => {
              console.log(error);
              this.loading = false;
            }
        );
      }
    },
    async removeCustomer(customer){
      const ok = await this.$refs.confirmDialogue.show({
        title: 'Slett fakturakunde "' + customer.name + '"',
        message: 'Vil du slette fakturakunden "' + customer.name + '"?',
        okButton: 'Slett',
        cancelButton: 'Avbryt'
      });
      if(ok) {
        customer.active = false;
        SettingsService.deleteInvoiceCustomer(customer).then(
            (response) => {
              if(response.data){
                this.loadCustomers();
              }
            },
            (error) => {
              console.log(error);
            }
        );
      }
    }
  }
};
</script>
